import { render, staticRenderFns } from "./MirotalkBlackboard.vue?vue&type=template&id=a1d2c7e6&scoped=true&"
import script from "./MirotalkBlackboard.vue?vue&type=script&lang=js&"
export * from "./MirotalkBlackboard.vue?vue&type=script&lang=js&"
import style0 from "./MirotalkBlackboard.vue?vue&type=style&index=0&id=a1d2c7e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d2c7e6",
  null
  
)

export default component.exports